import { Label } from '@/modules/shared/components/ui/label'
import {
  RadioGroup,
  RadioGroupItem,
} from '@/modules/shared/components/ui/radio-group'

type FilterType = 'codigo' | 'periodo'

type FilterTypeSelectorProps = {
  filterType: FilterType
  onChange: (value: FilterType) => void
}

export function OrderFilterTypeSelectorComponent({
  filterType,
  onChange,
}: FilterTypeSelectorProps) {
  return (
    <div className="mb-5">
      <Label htmlFor="filterType">Filtrar por:</Label>
      <RadioGroup
        className="mt-3 flex"
        onValueChange={onChange}
        defaultValue={filterType}
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="codigo" id="r1" />
          <Label htmlFor="r1">Código</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="periodo" id="r2" />
          <Label htmlFor="r2">Período</Label>
        </div>
      </RadioGroup>
    </div>
  )
}
